import { Tractor, Warehouse, ShieldCheck, Truck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
const features = [{
  title: "Home Equity Conversion",
  description: "Strategic extraction of airpark property value to establish a dedicated, non-depleting care reserve.",
  icon: Warehouse
}, {
  title: "Aircraft Lease-Backs",
  description: "Technical restructuring of aircraft ownership to generate liquidity while maintaining right-seat access.",
  icon: Tractor
}, {
  title: "Asset Protection",
  description: "Steel-clad financial engineering designed to shield principal savings from long-term care erosion.",
  icon: ShieldCheck
}, {
  title: "The Care Reserve",
  description: "A perpetual funding mechanism that ensures professional in-home care without exhausting your estate.",
  icon: Truck
}];
export default function PhaseIiStructuredPlanning() {
  return <section data-section-id="257457" id="phase-ii-structured-planning" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="text-primary font-mono font-semibold tracking-widest uppercase text-sm mb-4 block">
            Phase II: Financial Engineering
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground tracking-tight">
            The No-Depletion Guarantee
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className="bg-card border-border rounded-md hover:border-primary/50 transition-colors shadow-sm">
                <CardHeader className="items-center text-center pb-4">
                  <div className="mb-3 p-3 rounded-md bg-secondary/50 border border-border">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-lg font-default font-bold text-foreground uppercase tracking-wide">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <CardDescription className="text-muted-foreground text-sm leading-relaxed font-sans">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}